module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-5-3d750282494a17d06439ad00c776150d.jpg";